export const formatDateRange = (
  startDate?: string | null,
  endDate?: string | null
): string => {
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const parse = (dStr?: string | null) => {
    if (!dStr) return null;
    const d = new Date(dStr);
    return isNaN(d.getTime()) ? null : d;
  };

  const start = parse(startDate);
  const end = parse(endDate);

  const formatSingle = (d: Date) =>
    `${months[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`;

  if (start && end) {
    return `${formatSingle(start)} – ${formatSingle(end)}`;
  }
  if (start) return `Starts ${formatSingle(start)}`;
  if (end) return `Ends ${formatSingle(end)}`;
  return "No deadline set";
};

export const formatMetric = (
  val: string | number | null | undefined
): string => {
  if (val === null || val === undefined) return "-";
  if (typeof val === "string" && val.trim() === "") return "-";
  const num = typeof val === "string" ? parseFloat(val) : val;
  if (isNaN(num)) return typeof val === "string" ? val : "-";
  if (num >= 1000000) {
    return `${(num / 1000000).toFixed(1).replace(/\.0$/, "")}M`;
  }
  if (num >= 1000) {
    return `${(num / 1000).toFixed(1).replace(/\.0$/, "")}K`;
  }
  return num.toString();
};

export const formatEngagement = (
  rate: number | null | undefined
): string => {
  if (rate === null || rate === undefined) return "-";
  return `${rate.toFixed(1).replace(/\.0$/, "")}%`;
};
